import React from 'react';

import { Grid, Typography, Container, Button, makeStyles } from '@material-ui/core';

import { usePackagePlanStyles } from './styles';

export default ({ onSelect, mostPopularText, planName, price, previousPrice, description, billingNote, btnText }) => {
  const classes = usePackagePlanStyles();
  return (
    <Grid item style={{ alignItems: 'center' }} xs={12} className={classes.planWithBorder}>
      <Typography className={mostPopularText ? classes.packagePopular : classes.packagePopularHidden}>{mostPopularText}</Typography>
      <Typography className={classes.packageName}>{planName}</Typography>
      <Typography className={classes.previousPrice}>${previousPrice}</Typography>
      <Typography className={classes.packagePrice}>${price}</Typography>
      <Container className={classes.packageDescription2Container}>{description}</Container>
      <Container className={classes.packageOtherContainer}>
        <Typography className={classes.packageOther}>{billingNote}</Typography>
      </Container>
      <Container className={classes.selectContainer}>
        <Button variant="contained" color="primary" onClick={() => onSelect()}>
          {btnText}
        </Button>
      </Container>
    </Grid>
  );
};
